import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { setCurrentPromoOnboardingStep } from 'src/app/state/actions/promoPageSignUp';
import {
  getAccountReferral,
  getCurrentPromoOnboardingStepIndex,
  getPreviousPathName,
  getPromoCodeOnboarding,
  getPromoOnboardingSteps,
} from 'src/app/state/selectors';
import type { Dispatch } from 'src/app/state/store';

import { PromoOnboardingStepsRenderer } from '.';

const mapStateToProps = createStructuredSelector({
  currentStepIndex: getCurrentPromoOnboardingStepIndex,
  previousPathname: getPreviousPathName,
  promoCode: getAccountReferral,
  promoOnboardingPromoCode: getPromoCodeOnboarding,
  promoOnboardingSteps: getPromoOnboardingSteps,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  navigateToOnboardingStep: (stepNumber: number) => dispatch(setCurrentPromoOnboardingStep(stepNumber)),
});

const connector = connect(mapStateToProps, mapDispatchToProps);

export type PropsFromRedux = ConnectedProps<typeof connector>;
export const PromoOnboardingSteps = connector(PromoOnboardingStepsRenderer);
